import React, { useContext } from 'react';
import { TriggerContext } from '../../../../..';
import { StyledIOSAlertLivePreview, StyledIOSAlertHeadline, StyledIOSAlertText,
  StyledIOSBoldButton, StyledIOSAlertButton, StyledAndroidAlertHeadline,
  StyledAndroidAlertLivePreview, StyledAndroidAlertText, StyledAndroidButton } from './StyledAlertPreview';
import { getPropertyType } from '../../../../../../../../redux/store/store-helper';
import { PROPERTY_TYPES } from '../../../../../../../../common/constants';
import AlchemyAndroidFonts from '../../../../../../../../resources/assets/neb-icons/fonts/BannerPreviewFonts/mobileAndroid/AlchemyAndroidFonts';

const AlertPreview = ({ isDarkEnabled }) => {
  const { triggerState } = useContext(TriggerContext);
  const propertyType = getPropertyType();
  const {
    trigger: {
      invitationHeadline,
      invitationText,
      provideButtonText,
      laterButtonText,
      declineButtonText,
    } } = triggerState;
  
  const StyledAlertPreview = propertyType === PROPERTY_TYPES.IOS ? StyledIOSAlertLivePreview : StyledAndroidAlertLivePreview;
  const StyledHeadline = propertyType === PROPERTY_TYPES.IOS ? StyledIOSAlertHeadline : StyledAndroidAlertHeadline;
  const StyledAlertText = propertyType === PROPERTY_TYPES.IOS ? StyledIOSAlertText : StyledAndroidAlertText;
  const StyledAlertButton = propertyType === PROPERTY_TYPES.IOS ? StyledIOSAlertButton : StyledAndroidButton;

  return (
    <StyledAlertPreview isDarkEnabled={isDarkEnabled}>
      <AlchemyAndroidFonts/>
      <StyledHeadline isDarkEnabled={isDarkEnabled}>{invitationHeadline}</StyledHeadline>
      <StyledAlertText isDarkEnabled={isDarkEnabled}>{invitationText}</StyledAlertText>
      <StyledAlertButton>{provideButtonText}</StyledAlertButton>
      {propertyType === PROPERTY_TYPES.ANDROID && <StyledAndroidButton>{declineButtonText}</StyledAndroidButton>}
      <StyledAlertButton isSeparator>{laterButtonText}</StyledAlertButton>
      {propertyType === PROPERTY_TYPES.IOS && <StyledIOSBoldButton>{declineButtonText}</StyledIOSBoldButton>}
    </StyledAlertPreview>
  );
};

export default AlertPreview;